import { Location } from '@angular/common';
import { Component, ErrorHandler, Injectable, OnDestroy, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { CommonServiceService } from '../../services/common-service.service';
import { NavService } from '../../services/nav.service';
import { ToastrService } from 'ngx-toastr';
import { MinMaxCheckService } from '../../services/min-max-check.service';
import { FormatDateService } from '../../services/format-date.service';
import { AuthService } from 'src/app/pages/auth/auth.service';
import { RoleId, User } from 'src/app/pages/auth/role';
import { LocalStorageService } from '../../services/local-storage.service';

@Injectable({
  providedIn: 'root',
})
@Component({
  selector: 'app-base-component',
  templateUrl: './base-component.component.html',
  styleUrl: './base-component.component.scss',
})
export class BaseComponent implements OnInit, OnDestroy {
  protected route: ActivatedRoute = inject(ActivatedRoute);
  protected authService: AuthService = inject(AuthService);
  protected navService: NavService = inject(NavService);
  protected minMaxService: MinMaxCheckService = inject(MinMaxCheckService);
  protected dateFormatService: FormatDateService = inject(FormatDateService);
  protected toastr: ToastrService = inject(ToastrService);
  protected errorHandler: ErrorHandler = inject(ErrorHandler);
  protected router: Router = inject(Router);
  protected location: Location = inject(Location);
  protected commonService: CommonServiceService = inject(CommonServiceService);
  protected localStorageService: LocalStorageService = inject(LocalStorageService);
  protected Swal = Swal;
  protected loggedUser: User;
  protected RoleId = RoleId;

  constructor() {
    this.loggedUser = this.authService.getUser();
  }

  ngOnInit() {  }

  ngOnDestroy() {  }
}

export class BaseComponentHeader extends BaseComponent {
  constructor() {
    super();
  }
}
export class BaseComponentFooter extends BaseComponent {
  constructor() {
    super();
  }
}
